import { useMutation } from 'react-query';

import { getConfigByIdAsync, updateConfigAsync } from '../index';

export const useGetConfigByIdAsync = () =>
  useMutation(getConfigByIdAsync);

export const useUpdateConfigAsync = () =>
  useMutation(updateConfigAsync);

